var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0832 26.75V23.9167C24.0832 22.4138 23.4861 20.9724 22.4234 19.9097C21.3607 18.847 19.9194 18.25 18.4165 18.25H7.08317C5.58028 18.25 4.13894 18.847 3.07623 19.9097C2.01353 20.9724 1.4165 22.4138 1.4165 23.9167V26.75M32.5832 26.75V23.9167C32.5822 22.6611 32.1643 21.4414 31.3951 20.4491C30.6259 19.4568 29.5489 18.7481 28.3332 18.4342M22.6665 1.43417C23.8854 1.74626 24.9658 2.45516 25.7373 3.44911C26.5088 4.44305 26.9276 5.66551 26.9276 6.92375C26.9276 8.18199 26.5088 9.40445 25.7373 10.3984C24.9658 11.3923 23.8854 12.1012 22.6665 12.4133M18.4165 6.91667C18.4165 10.0463 15.8795 12.5833 12.7498 12.5833C9.62022 12.5833 7.08317 10.0463 7.08317 6.91667C7.08317 3.78705 9.62022 1.25 12.7498 1.25C15.8795 1.25 18.4165 3.78705 18.4165 6.91667Z",
    stroke: "#B2FC02",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGreen);
export default __webpack_public_path__ + "static/media/usersGreen.5d0334f1143a267380e0b12236fc9b25.svg";
export { ForwardRef as ReactComponent };